import { lazy } from 'react';

import LazyWithRetry from '../../components/shared/LazyWithRetry';
import LazyWithSuspense from '../../components/shared/LazyWithSuspense';

const InspirationLibraryMainLazy = LazyWithSuspense(
    lazy(
        () =>
            LazyWithRetry(
                () => import('./InspirationLibraryMain'),
                'inspiration-library-main',
            ) as any,
    ),
);

export default InspirationLibraryMainLazy;
